<div
  class="flex items-center justify-between border-b border-slate-200 px-6 py-4"
>
  <div>
    <h2
      id="modal-eliminar-telefono-title"
      class="text-lg font-semibold text-slate-900"
    >
      Eliminar teléfono
    </h2>
    <p class="text-sm text-slate-500">
      Confirma si deseas borrar este teléfono de la sede.
    </p>
  </div>

  <button
    type="button"
    class="rounded-lg p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
    (click)="cerrarModal()"
    aria-label="Cerrar modal"
  >
    <i class="bi bi-x-lg text-lg"></i>
  </button>
</div>

<div class="space-y-4 px-6 py-5">
  <div class="rounded-xl bg-slate-50 p-4 text-sm text-slate-700">
    <p class="font-semibold text-slate-900">{{ telefono().titulo }}</p>
    <p>{{ telefono().numero }}</p>
    <p class="text-slate-500">
      {{ telefono().descripcion || "Sin descripción" }}
    </p>
  </div>

  <p class="text-sm text-slate-700">
    Esta acción no se puede deshacer. ¿Deseas eliminar este teléfono?
  </p>

  <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
    <button
      type="button"
      class="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm font-medium text-slate-700 transition hover:bg-slate-50 sm:w-auto"
      (click)="cerrarModal()"
    >
      Cancelar
    </button>

    <button
      type="button"
      class="w-full rounded-xl bg-red-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-red-700 sm:w-auto"
      (click)="confirmarEliminar()"
    >
      Sí, eliminar
    </button>
  </div>
</div>

<app-toast aria-live="polite" aria-atomic="true"></app-toast>
